import React from 'react'
import Bg from '@images/team/team-bg.webp'
import team1 from '@images/team/team1.webp'
import team2 from '@images/team/team2.webp'
import team3 from '@images/team/team3.webp'


const TeamSection = (props) => {

    return (
        <section className="team-section mb-240" style={{ backgroundImage: `url(${Bg})` }}>
            <div className="team-wrap">
                <div className="container">
                    <div className="section-title text-white text-center mb-55">
                        <h2>Poznaj nasz <span className="thin">zespół</span></h2>
                        <h6>członkowie naszego teamu</h6>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="team-item">
                                <img src={team1} alt="Team"/>
                                <div className="team-des">
                                    <h3>Paweł</h3>
                                    <span>CEO </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="team-item">
                                <img src={team2} alt="Team"/>
                                <div className="team-des">
                                    <h3>Ula</h3>
                                    <span>Manager </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="team-item">
                                <img src={team3} alt="Team"/>
                                <div className="team-des">
                                    <h3>Piotr</h3>
                                    <span>Manager </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TeamSection;
